import React from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import HeroPremiumLineGraph from './HeroPremiumLineGraph';
import HeroTopInsurers from './HeroTopInsurers';
import HeroCountyHeatMap from './HeroCountyHeatMap';
import HeadlineOne from './HeadlineOne';
import HeadlineTwo from './HeadlineTwo';
import HeadlineThree from './HeadlineThree';
import ScrollForMore from './ScrollForMore';

import { getSummary } from 'state/actions';
import './index.css';

const HomePage = ({
  summary: {
    year,
    quarter,
    quarterlyPremiumTrend,
    countyWiseData,
    allLines,
    commercialLines,
    maxAttemptsReached,
    fastFacts: {
      totalTransactionsSubmitted,
      totalPremiumCollected,
      noOfInsurersUnderWrotePolicies,
      percentOfPremiumWritten,
    } = {
      totalTransactionsSubmitted: 0,
      totalPremiumCollected: 0,
      noOfInsurersUnderWrotePolicies: 0,
      percentOfPremiumWritten: 0,
    },
  } = {
    quarterlyPremiumTrend: [],
    countyWiseData: [],
    allLines: [],
    commercialLines: [],
    fastFacts: {},
  },
  dispatch,
}) => {
  const height = '75vh';

  React.useEffect(() => {
    dispatch(getSummary());
  }, [dispatch]);

  return maxAttemptsReached ? (
    <div
      style={{
        height: '70vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography variant="h6" color="primary">
        An error occurred. Please reload this page to try again.
      </Typography>
    </div>
  ) : (
    <>
      <HeroPremiumLineGraph data={quarterlyPremiumTrend} year={year} quarter={quarter} />
      <ScrollForMore />
      <HeadlineOne
        height={height}
        totalTransactionsSubmitted={totalTransactionsSubmitted}
        year={year}
        quarter={quarter}
      />
      <HeroCountyHeatMap
        data={countyWiseData}
        totalPremiumCollected={totalPremiumCollected}
        year={year}
        quarter={quarter}
      />
      <HeadlineTwo
        height={height}
        noOfInsurersUnderWrotePolicies={noOfInsurersUnderWrotePolicies}
        year={year}
        quarter={quarter}
      />
      <HeroTopInsurers data={{ allLines, commercialLines }} year={year} quarter={quarter} />
      <HeadlineThree
        height={height}
        percentOfPremiumWritten={percentOfPremiumWritten}
        year={year}
        quarter={quarter}
      />
    </>
  );
};

export const mapStateToProps = ({ summary = {} }) => ({
  summary,
});

export default connect(mapStateToProps)(HomePage);
